import { render, staticRenderFns } from "./ExternalTicketUpdateItemFooter.vue?vue&type=template&id=b21981ae&"
import script from "./ExternalTicketUpdateItemFooter.vue?vue&type=script&lang=js&"
export * from "./ExternalTicketUpdateItemFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports